import React from "react";
import CardDireksi from "./CardDireksi";

function DibalikDanai() {
    return (
        <>
            <div className="container-4">
                <div className="backBox">
                    <div className="teamContainer" style={{marginTop: "0"}}>
                        <div className="teamtext text-center">
                            <h2 className="text-header" style={{marginBottom: "1rem"}}>Siapa
                                Dibalik <span>Danai.id</span></h2>
                            <p>
                                <strong>Danai.id</strong> didukung oleh jajaran Manajemen yang berpengalaman luas di bidang jasa keuangan.
                                Komisaris dan seluruh Direksi <strong>Danai.id</strong> terdiri dari profesional berpengalaman di industri perbankan dan regulator keuangan.
                            </p>
                            <p>
                                Dengan pengalaman dan wawasan yang mendalam tersebut, <strong>Danai.id</strong> berkomitmen menghadirkan praktik
                                terbaik serta layanan keuangan yang aman, transparan, dan berfokus pada kebutuhan pengguna.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-5 tentang-kami" style={{gap:"1rem"}}>
                <div className="section-title text-center">
                    <h2 className="text-header">Direksi & Komisaris</h2>
                </div>
                <div className="direksi-container max-w-7xl">
                    <CardDireksi
                        foto='photo-uki'
                        nama='Adimukyo Mardjikoen'
                        jabatan='Komisaris'
                        deskripsi='25+ tahun pengalaman dalam Bank Indonesia dan industri perbankan'
                    />
                    <CardDireksi
                        foto='photo-ir'
                        nama='Irianto Gunawan'
                        jabatan='Direktur Utama'
                        deskripsi='25+ tahun pengalaman di <em>Retail & Commercial Business</em>'
                    />
                    <CardDireksi
                        foto='photo-edwin'
                        nama='Edwin Tanu Teintang'
                        jabatan='Direktur'
                        deskripsi='25+ tahun pengalaman dalam industri perbankan dan pasar modal'
                    />
                </div>
            </div>
        </>
    );
}

export default DibalikDanai;